const GROUP_LABELS = {
  Company: 'Companies',
  School: 'Schools',
  College: 'Colleges / Universities',
  Club: 'Clubs',
  Gym: 'Gyms',
  Organisation: 'Organisations',
  'Collective Group': 'Collective Groups',
  Challenge: 'Challenges',
  Other: 'Other',
};

const GROUP_ORDER = Object.keys(GROUP_LABELS);

const workspaceType = (rows = []) => {
  const primary = rows.find((row) => row?.type !== 'Challenge' && !row?.teams)
    || rows.find((row) => row?.type !== 'Challenge')
    || rows[0];
  return GROUP_LABELS[primary?.type] ? primary.type : 'Other';
};

export const buildInstitutionWorkspaceGroups = (institutes = []) => {
  const rowsByWorkspace = new Map();
  institutes.forEach((institute) => {
    if (!institute?.workspace_id) return;
    const current = rowsByWorkspace.get(institute.workspace_id) || [];
    current.push(institute);
    rowsByWorkspace.set(institute.workspace_id, current);
  });

  const groups = new Map();
  rowsByWorkspace.forEach((rows, id) => {
    const type = workspaceType(rows);
    const option = {
      id,
      name: rows.find((row) => row?.workspace_name)?.workspace_name || rows[0]?.name || 'Workspace',
      type,
    };
    const current = groups.get(type) || [];
    current.push(option);
    groups.set(type, current);
  });

  return GROUP_ORDER
    .filter((type) => groups.has(type))
    .map((type) => ({
      type,
      label: GROUP_LABELS[type],
      options: groups.get(type).sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })),
    }));
};

export const mergeManagedInstituteRows = ({
  ownedRows = [],
  adminAssignments = [],
  administeredRows = [],
} = {}) => {
  const ownedIds = new Set(ownedRows.map((row) => row?.id).filter(Boolean));
  const adminRoleByInstitute = new Map(
    adminAssignments
      .filter((row) => row?.institute_id)
      .map((row) => [row.institute_id, row.role || 'admin']),
  );
  const rowsById = new Map();

  ownedRows.forEach((row) => {
    if (row?.id) rowsById.set(row.id, { ...row, access_role: 'owner' });
  });
  administeredRows.forEach((row) => {
    if (!row?.id || ownedIds.has(row.id) || rowsById.has(row.id)) return;
    rowsById.set(row.id, {
      ...row,
      access_role: adminRoleByInstitute.get(row.id) || 'admin',
    });
  });

  return [...rowsById.values()];
};

export const shouldShowAllInstituteGroups = (institute = {}) => (
  institute?.teams === true && ["School", "College"].includes(institute?.type)
);

export const visibleInstituteGroups = ({
  institute = {},
  groups = [],
  expanded = false,
  isMobile = false,
  hasSearch = false,
  desktopLimit = 4,
  mobileLimit = 3,
} = {}) => {
  if (shouldShowAllInstituteGroups(institute) || expanded || hasSearch) return groups;
  return groups.slice(0, isMobile ? mobileLimit : desktopLimit);
};
